import { useMutation, useQuery } from "@tanstack/react-query";
import { assignDroneUser, getalldrones } from "../../api/dronesAPI";
import { useAuthStore } from "../../store/authStore";
import { useForm } from "react-hook-form";
import { Task } from "@carbon/icons-react";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

const DroneAssignmentTab = ({ pilots }) => {
    const { token, setLoaderState } = useAuthStore((state) => state)
    const { data: dronesData } = useQuery({
        queryFn: getalldrones,
        queryKey: ["getDrones", token, "approved"],
        refetchOnWindowFocus: false,
    });
    const { register, handleSubmit, getValues } = useForm();

    const { mutate, data, error, isSuccess } = useMutation({
        mutationFn: assignDroneUser,
        onSuccess: () => {
            setLoaderState(false)
        }

    })

    const AssignDrone = () => {
        let data = getValues();
        let pilotEmail = "";
        let pilotName = ""
        for (let i = 0; i < pilots.length; i++) {
            if (pilots[i].userId == data.userId) {
                pilotEmail = pilots[i].email;
                pilotName = pilots[i].fullName
                break;
            }

        }
        data = { ...data, email: pilotEmail, pilotName }
        setLoaderState(true)
        mutate({ token, data })
    }

    useEffect(() => {
        if (error) {
            setLoaderState(false)
            toast.error(error?.response?.data?.message)
        }
    }, [error])

    useEffect(() => {
        setLoaderState(false)
    }, [])

    useEffect(() => {
        toast.success(data?.data?.message)
    }, [data])
    return (
        <>
            <form
                onSubmit={handleSubmit(AssignDrone)}
            >
                <ToastContainer />
                <div className="space-y-6 mt-10">
                    <div>
                        <h2 className="text-tblu capitalize">Choose Pilot*</h2>
                        <select
                            {...register("userId", { required: true })}
                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none"
                        >
                            {pilots?.map((pilot, index) => (
                                <option key={index} value={pilot.userId}>
                                    {pilot.fullName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <span>
                            <h2 className="text-tblu">Select drone*</h2>
                            <select
                                {...register("droneId", { required: true })}
                                className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none"
                            >
                                {dronesData?.data?.data?.map((drone, index) => (
                                    <option key={index} value={drone.droneId}>
                                        {drone.droneName}
                                    </option>
                                ))}
                            </select>
                        </span>
                    </div>
                    <div>
                        <button
                            className="text-xl mt-10 bg-tblu text-white flex justify-center items-center w-full p-4 space-x-1 rounded-xl"
                        >
                            <span><Task /></span> <span>Assign</span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default DroneAssignmentTab